<template>
  <div class="slider">
    <vue-slider @drag-start="dragging = true" @drag-end="dragEnd" @change="conditionalFocusOut"
                v-model="value" :min="minValue" :max="maxValue" :interval="step" :disabled="disabled"/>
  </div>
</template>

<script>
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/antd.css'

export default {
  components: {
    VueSlider
  },
  name: "Slider",
  props: {
    min: Number,
    max: Number,
    id: String,
    step: Number,
    valueProp: Number,
    dataRef: String,
    disabled: Boolean
  },
  data: () => ({
    value: 0,
    dragging: false,
    maxValue: Infinity,
    minValue: null,
  }),
  created() {
    if (this.max)
      this.maxValue = Math.round(this.max / this.step) * this.step;
    if (this.min)
      this.minValue = Math.ceil(this.min / this.step) * this.step;

    this.handleInitValue();
  },
  updated() {
    this.handleInitValue();
  },
  methods: {
    handleInitValue() {
      if (!this.valueProp)
        this.value = this.min;
      else
        this.value = this.valueProp

      if (this.value < this.minValue) this.value = this.minValue;
    },
    conditionalFocusOut() {
      if (!this.dragging) {
        this.$emit("focusout");
      }
    },
    dragEnd() {
      this.dragging = false;
      this.$emit("focusout");
    }
  },
  watch: {
    value(to) {
      if (to || to === 0)
        this.$emit("change", {id: this.id, value: to, dataRef: this.dataRef});
    },
    valueProp(to) {
      this.value = to;
    },
    max(to) {
      this.maxValue = Math.round(to / this.step) * this.step;
    },
    min(to) {
      this.minValue = Math.ceil(to / this.step) * this.step;
    }
  }
}
</script>

<style lang="scss">

</style>